import React, { useEffect } from 'react';
import "../allcss/Karan.css";
import Popup_video from '../Asets/Popup_video.mp4';
import RedSchoolHouseLogo from '../Asets/redlogo1.png';

const VideoPopup = ({ onClose }) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

useEffect(() => {
    window.scrollTo(0, 0); // 👈 Scroll to top on page load
  }, []);
 

  return (


    <div className="popup-overlay">
      <div className="popup-box">
      <button className="button" onClick={onClose}>
  <div className="X"></div>
  <div className="Y"></div>

</button>

        <div className="popup-header">
          <p className="popup-subtitle">Multi Award Winning Preschool Chain from Singapore </p>
          <h1 className="popup-title">ADMISSION <br /> OPEN NOW!</h1>
          
        </div>

        <div className="popup-content">
          <img src={RedSchoolHouseLogo} alt="Red SchoolHouse Logo" className="popup-logo" />
          <p className="popup-tagline">Settling the heart, defining your child.</p>

          <div className="popup-benefits">
            <h2>LEARNING BENEFITS</h2>
            <ul>
              <li>International Standard</li>
              <li>360 Degree Support</li>
              <li>Holistic Curriculum</li>
              <li>Extensive Professional Development Programmes</li>
            </ul>
          </div>


          <div className="popup-program-tags">
            <span>PLAY GROUP</span> | <span>NURSERY</span> | <span>JR KG</span> | <span>SR KG</span> | <span>DAY CARE</span>
          </div>

          <div className="popup-contact-info">
            <p className="enquire-now">Enquire Now!</p>
            <div className="phone-social-row">
              <p className="phone-number">📞 +91 7778851070</p>
              <div className="social-icons">📷 🅕</div>
            </div>
            <p className="popup-address">A-25, Castle white, Opp. main Harni Water Tank, Harni Sama Link Road, Vadodara.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoPopup;
